/** Pure helpers for the booking wizard — keeps Booking.jsx free of nested ternaries. */

export function memberFor(memberInfo, tier) {
  if (!memberInfo?.member || !tier) return null;
  return { ...memberInfo, included: memberInfo.included_available && memberInfo.included_service === tier.id };
}

export function memberPriceFor(tier, member) {
  if (!tier) return null;
  if (member?.included) return "0.00";
  if (member) return (Number(tier.price) * (1 - member.discount_pct / 100)).toFixed(2);
  return tier.price;
}

export function payLabelFor(member, price) {
  if (member?.included) return "Book — included in membership";
  return `Book session · $${price} after`;
}

export function canProceed(step, tier, slot, form) {
  if (step === 0) return !!tier;
  if (step === 1) return !!slot;
  return form.name.length > 1 && /\S+@\S+\.\S+/.test(form.email) && form.phone.length >= 7;
}

export function doneMessage(done) {
  if (done.payment === "gift") return "Paid with your gift code — your session is confirmed. See you then!";
  if (done.payment === "membership") return "Included in your membership — nothing to pay, your session is confirmed. See you then!";
  return `Nothing to pay today. After your session, David will email you a secure card payment link for $${Number(done.amount_usd || 0).toFixed(2)}.`;
}

export function stepTone(i, step) {
  if (i === step) return "text-cyan-400";
  if (i < step) return "text-slate-300";
  return "text-slate-600";
}
